import React from "react"
import PropTypes from "prop-types"
import { Modal, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import styles from "./UnsavedChangesModal.module.css"

const UnsavedChangesModal = ({ open, onDiscard, onKeepEditing, zIndex = 1100 }) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onCancel={onKeepEditing}
      footer={null}
      width={370}
      className={styles.modal}
      maskClosable={false}
      zIndex={zIndex}
      closeIcon={
        <span className={styles.closeIcon}>
          <Icon type="feather" name="X" />
        </span>
      }
    >
      <h2 className={styles.title}>{t("common.unsaved_changes_modal.title")}</h2>
      <div className={styles.body}>
        <p className={styles.description}>{t("common.unsaved_changes_modal.description")}</p>
      </div>
      <Flex gap={12} className={styles.footer}>
        <Button size="large" danger onClick={onDiscard}>
          {t("common.unsaved_changes_modal.discard")}
        </Button>
        <Button size="large" onClick={onKeepEditing}>
          {t("common.unsaved_changes_modal.keep_editing")}
        </Button>
      </Flex>
    </Modal>
  )
}

UnsavedChangesModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onDiscard: PropTypes.func.isRequired,
  onKeepEditing: PropTypes.func.isRequired,
  zIndex: PropTypes.number
}

export { UnsavedChangesModal }
